import type {
  AnyWidgetDef,
  ComingSoonWidgetDef,
  FeOnlyWidgetDef,
  WidgetDef,
} from '@core/dashboard-types';
import { WidgetType } from '@core/dashboard-types';

export const isComingSoonWidgetDef = (widgetDef: AnyWidgetDef): widgetDef is ComingSoonWidgetDef =>
  widgetDef.type === WidgetType.ComingSoonDrawer;

export const isFeOnlyWidgetDef = (widgetDef: AnyWidgetDef): widgetDef is FeOnlyWidgetDef =>
  widgetDef.type === WidgetType.FeOnly;

export const isDrawerWidgetDef = (widgetDef: AnyWidgetDef): widgetDef is WidgetDef =>
  widgetDef.type === WidgetType.Drawer;
